import React from 'react';
import './WhySection.css';

const WhySection = () => (
  <div id="how" className="how-maia-section mt-5 mb-5 container">
    {/* How MAIA Delivers Better Care Section */}
    <div className="row">
      <div className="col-12">
        <h3 className="how-maia-title text-center mb-5 pb-5">How MAIA Delivers Better Care in Real Time</h3>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-4 mb-4">
        <div className="step-card step-card-white">
          <div className="step-number">01</div>
          <h4 className="step-title">Ask MAIA</h4>
          <p className="step-description">Real clinical questions, in plain language.</p>
        </div>
      </div>
      <div className="col-12 col-md-4 mb-4">
        <div className="step-card step-card-white">
          <div className="step-number">02</div>
          <h4 className="step-title">Get Role-Aware Responses</h4>
          <p className="step-description">MAIA adapts to your profession, specialty, and patient scenario.</p>
        </div>
      </div>
      <div className="col-12 col-md-4 mb-4">
        <div className="step-card step-card-white">
          <div className="step-number">03</div>
          <h4 className="step-title">Trust the Source</h4>
          <p className="step-description">Built on 25+ years of NYSORA's peer-reviewed textbooks, videos, and global medical community.</p>
        </div>
      </div>
    </div>
  </div>
);

export default WhySection; 